<template>
    <div class="switch-buttons-group">
        <slot />
    </div>
</template>

<style lang="scss">
.switch-buttons-group {

    display: flex;
    padding: 6px;
    align-items: flex-start;
    gap: 6px;

    border-radius: 4px;
    background: var(--black-25, rgba(25, 25, 25, 0.25));

    

}
</style>